import * as yup from 'yup'

export const TransfixFlagEditModalSchema = yup.object({
  transfixHolder: yup.boolean().nullable(),
  transfixAdditionalInsured: yup.boolean().nullable(),
  transfixLossPayee: yup.boolean().nullable(),
})

export type TTransfixFlagEditModalSchema = yup.InferType<typeof TransfixFlagEditModalSchema>
